import apiClient from "./apiClient";

/* CREATE SERVICE */
export const createService = async (serviceData) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.post(
    "admin/services", // ✅ FIXED
    serviceData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        
      }
    }
  );

  return response.data;
};

/* GET ALL SERVICES */
export const getAllServices = async () => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    "admin/services", // ✅ FIXED
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};



export const toggleServiceStatus = async (serviceId) => {
    const token = localStorage.getItem("token");

    const response = await apiClient.patch(
        `admin/services/${serviceId}/toggle-active`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.data; // updated service
};


/* GET SERVICE BY ID */
export const getServiceById = async (id) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    `admin/services/${id}`, // ✅ FIXED
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

/* GET PARENT SERVICES */
export const getParentServices = async () => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    "admin/services",
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data.filter(s => s.parentServiceId === null);
};

export const updateService = async (serviceId, payload) => {
    const token = localStorage.getItem("token");

    const response = await apiClient.put(
        `admin/services/${serviceId}`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.data;
};

/* GET ALL SERVICE GROUPS */
export const getAllServiceGroups = async () => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    "ServiceGroups",
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

/* CREATE SERVICE GROUP */
export const createServiceGroup = async (data) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.post(
    "ServiceGroups",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

/* UPDATE SERVICE GROUP */
export const updateServiceGroup = async (id, data) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.put(
    `ServiceGroups/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

export const assignServiceToGroup = async (serviceId, data) => {
  try {
    const token = localStorage.getItem("token");

    const response = await apiClient.put(
      `admin/services/${serviceId}/assign-group`,
      data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;

  } catch (error) {
    console.error("Error assigning service to group:", error);
    throw error;
  }
};